import * as React from 'react'
import styled from 'styled-components'
import * as MediaUtils from '../modules/mediaUtils'
import logo from '../assets/logo.svg'
import { Button } from '@material-ui/core'

type Props = {
    address?: string
}

export const Component = (props: Props) => {
    const onClickTip = async () => {
        const accounts = await window.ethereum.request({
            method: 'eth_requestAccounts'
        })
        const account = accounts[0]
        const transactionParameters = {
            to: '0xA0167495ECB512CAf516B76873D4d5024e05d510',
            from: account,
            value: '0x2386F26FC10000'
        }
        try {
            await window.ethereum.request({
                method: 'eth_sendTransaction',
                params: [transactionParameters]
            })
        } catch (err) {
            console.error(err)
        }
    }

    const [userIcon, userAddress] = React.useMemo(() => {
        if (props?.address) {
            return [
                <SButton
                    variant="contained"
                    color="secondary"
                    onClick={onClickTip}
                >
                    Tip ❤️ with Metamask
                </SButton>,
                <Address>
                    {props.address.slice(0, 6)}...
                    {props.address.slice(-4)}
                </Address>
            ]
        } else {
            return [
                <SButton
                    variant="contained"
                    color="secondary"
                    onClick={onClickTip}
                >
                    Tip ❤️ with Metamask
                </SButton>,
                null
            ]
        }
    }, [props?.address])
    return (
        <Wrap>
            <HeaderContents>
                <Logo src={logo} height="32px" />
            </HeaderContents>
            <HeaderContents>
                {userAddress}
                {userIcon}
            </HeaderContents>
        </Wrap>
    )
}

//------------------------------------------------------------------------------
// Styles
//------------------------------------------------------------------------------

const Wrap = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 16px 24px;
    border-bottom: thin solid #d7cece;
    ${MediaUtils.customMedia.lessThan('mobile')`
    padding: 8px 8px 8px 12px;
    `}
`
const HeaderContents = styled.div`
    display: flex;
`
const Logo = styled.img``

const Address = styled.div`
    background-color: white;
    border-radius: 10px;
    font-size: 16px;
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
    padding: 10px;
    color: ${props => props.theme.palette.text.secondary};
`

const SButton = styled(Button)`
    background: linear-gradient(45deg, #fda9bd 30%, #f6b795 90%);
`
